// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Crew Hiring Configuration
 * 
 * Defines available crew roles and experience levels for hiring
 */

import { CREW_ROLES } from '../utils/game/CrewManager';

export const EXPERIENCE_LEVELS = {
  ROOKIE: { id: 'ROOKIE', name: 'Rookie', multiplier: 0.8, costMultiplier: 1.0 },
  TRAINED: { id: 'TRAINED', name: 'Trained', multiplier: 1.0, costMultiplier: 1.5 },
  EXPERIENCED: { id: 'EXPERIENCED', name: 'Experienced', multiplier: 1.2, costMultiplier: 2.0 },
  VETERAN: { id: 'VETERAN', name: 'Veteran', multiplier: 1.4, costMultiplier: 3.0 },
  ELITE: { id: 'ELITE', name: 'Elite', multiplier: 1.6, costMultiplier: 5.0 }
};

// Convert CREW_ROLES to shop items format
export const crewRoles = Object.keys(CREW_ROLES).map(roleKey => {
  const role = CREW_ROLES[roleKey];
  return {
    id: roleKey,
    name: role.name,
    icon: role.icon,
    description: role.bonus,
    basePrice: role.hireCost,
    price: role.hireCost, // Default to TRAINED level
    stats: {
      'Base Bonus': role.bonus,
      'Hire Cost': `${role.hireCost} CR`
    },
    // Store role data for hiring
    roleData: role
  };
});

export const calculateCrewCost = (basePrice, experienceLevel) => {
  const exp = EXPERIENCE_LEVELS[experienceLevel];
  return Math.floor(basePrice * exp.costMultiplier);
};
